export default {
  PORT: process.env.PORT || 8000,
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || "http://localhost:8000/api",
    API_TOKEN: process.env.API_TOKEN,
  }

  // "http://localhost:8000/api"
  // 'https://stark-earth-91003.herokuapp.com/api'